var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkColored(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_bulk_link-2",
    "data-name": "vuesax/bulk/link-2",
    transform: "translate(-108 -252)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "link-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.05,1.928a6.584,6.584,0,0,1-3.09,11.05,6.564,6.564,0,0,0-1.74-6.22A6.564,6.564,0,0,0,0,5.018a6.584,6.584,0,0,1,11.05-3.09Z",
    transform: "translate(116.02 255.003)",
    fill: "#fd4082",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M11.238,1.93A6.582,6.582,0,1,1,5.018.19,6.564,6.564,0,0,1,11.238,1.93Z",
    transform: "translate(111.003 259.83)",
    fill: "#fd4082",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M11.227,11.234A.728.728,0,0,1,10.2,10.2a5.119,5.119,0,1,0-7.24,0,.728.728,0,0,1-1.03,1.03,6.583,6.583,0,1,1,9.3,0Z",
    transform: "translate(115.842 255.006)",
    fill: "#fd4082"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M1.929.218a.718.718,0,0,1,1.03,0,.718.718,0,0,1,0,1.03,5.119,5.119,0,1,0,7.24,0,.718.718,0,0,1,0-1.03.718.718,0,0,1,1.03,0,6.583,6.583,0,1,1-9.3,0Z",
    transform: "translate(111.001 261.543)",
    fill: "#fd4082"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-5",
    "data-name": "Vector",
    d: "M0,0H24V24H0Z",
    transform: "translate(108 252)",
    fill: "none",
    opacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkColored);
export default __webpack_public_path__ + "static/media/link-colored.1c35524a4abdaa4a6702cc7c0fb3e53c.svg";
export { ForwardRef as ReactComponent };